import { styled } from '@linaria/react';
import { isNonEmptyString } from '@sniptt/guards';
import { themeCssVariables } from 'app-ui/theme';
import { type ReactNode, useId } from 'react';

import { useIsNavigationDrawerCollapsed } from '@/ui/layout/navigation-drawer/hooks/useIsNavigationDrawerCollapsed';

const StyledSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${themeCssVariables.betweenSiblingsGap};
`;

const StyledTitle = styled.div`
  align-items: center;
  color: ${themeCssVariables.font.color.light};
  display: flex;
  font-size: ${themeCssVariables.font.size.xs};
  font-weight: ${themeCssVariables.font.weight.semiBold};
  height: ${themeCssVariables.spacing[6]};
  overflow: hidden;
  padding: 0 ${themeCssVariables.spacing[2]};
  text-overflow: ellipsis;
  white-space: nowrap;
`;

type NavigationDrawerSectionProps = {
  title?: string;
  children: ReactNode;
};

export const NavigationDrawerSection = ({
  title,
  children,
}: NavigationDrawerSectionProps) => {
  const titleId = useId();
  const isCollapsed = useIsNavigationDrawerCollapsed();
  const hasVisibleTitle = isNonEmptyString(title) && !isCollapsed;

  return (
    <StyledSection
      role="group"
      aria-labelledby={hasVisibleTitle ? titleId : undefined}
      aria-label={hasVisibleTitle ? undefined : title}
    >
      {hasVisibleTitle && <StyledTitle id={titleId}>{title}</StyledTitle>}
      {children}
    </StyledSection>
  );
};
